function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["firstZero", "prefix", "suffix", "type", "placeholder", "allowClear", "visible", "className", "width", "height", "size", "value", "defaultValue", "variant", "onEnter", "onChange", "onPaste", "style", "numberControl", "step"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { cn } from "../../../lib/utils";
import { EmptyIcon, EyeoffIcon, EyeonIcon, PlusIcon, ReduceIcon } from '@bfe/moly-icons';
import { css } from '@emotion/css';
import { cva } from 'class-variance-authority';
import React, { useEffect, useState } from 'react';
import { IconButton } from "../iconbutton";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var inputVariants = cva(['color-[#121214]'], {
  variants: {
    variant: {
      default: [''],
      error: ['border-[#EF454A]', 'focus-visible:border-[#EF454A]', 'hover:outline-none hover:border-[#EF454A]']
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
var fontSizeVariable = {
  xs: ['text-[12px] font-medium leading-[18px]'],
  small: ['text-[12px] font-medium leading-[18px]'],
  medium: ['text-[16px] font-medium leading-6'],
  'x-large': ['text-[20px] leading-6 font-medium leading-7']
};
var containerVariable = {
  xs: 'h-[32px] px-[7px] rounded gap-[8px]',
  small: 'h-[40px] pl-[11px] pr-[9px]  rounded gap-[8px]',
  medium: 'h-[48px] pl-[15px] pr-[13px] rounded-lg gap-[8px]',
  'x-large': 'h-[64px] pl-[19px] pr-[17px] rounded-lg gap-[8px]'
};
var inputStyle = css("\n  &::placeholder {\n      font-weight: 400; \n  }\n  ");
var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var firstZero = _ref.firstZero,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    placeholder = _ref.placeholder,
    allowClear = _ref.allowClear,
    visible = _ref.visible,
    className = _ref.className,
    width = _ref.width,
    height = _ref.height,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    value = _ref.value,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    onEnter = _ref.onEnter,
    _onChange = _ref.onChange,
    _onPaste = _ref.onPaste,
    style = _ref.style,
    _ref$numberControl = _ref.numberControl,
    numberControl = _ref$numberControl === void 0 ? true : _ref$numberControl,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focusStatus = _useState2[0],
    setFocusStatus = _useState2[1];
  var _useState3 = useState(value || defaultValue),
    _useState4 = _slicedToArray(_useState3, 2),
    inputValue = _useState4[0],
    setInputValue = _useState4[1];
  var _useState5 = useState(type === 'number' ? 'text' : type),
    _useState6 = _slicedToArray(_useState5, 2),
    inputType = _useState6[0],
    setInputType = _useState6[1];
  var getIconSize = function getIconSize() {
    var iconSize = size;
    if (size === 'small') {
      iconSize = 'xs';
    }
    if (['medium', 'x-large'].includes(size) || !size) {
      iconSize = 'small';
    }
    return iconSize;
  };
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    passwordVisible = _useState8[0],
    setPasswordVisible = _useState8[1];
  var onClear = function onClear() {
    setInputValue('');
    _onChange === null || _onChange === void 0 ? void 0 : _onChange({
      target: {
        value: ''
      }
    });
  };
  var checkNum = function checkNum(val) {
    var firstChar = val.charAt(0);
    // 转化为数字形式，包含小数 负数
    var value = val.replace(/[^\d.]/g, '');
    // 第一个数字非.
    // value = value.replace(/[^./]/g, '');
    // 只允许出现一次 . ,不会连续出现2次
    value = value.replace(/\.{2,}/g, '');
    // 保存只有出现一次 .
    value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
    if (firstChar === '-') {
      value = '-' + value;
    }
    return value;
  };
  var plusHandler = function plusHandler() {
    var arg1 = (inputValue === null || inputValue === void 0 ? void 0 : inputValue.toString()) || '0';
    var arg2 = step.toString();
    var r1, r2, m;
    try {
      r1 = arg1.split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    var result = (arg1 * m + arg2 * m) / m + '';
    setInputValue(result);
    _onChange === null || _onChange === void 0 ? void 0 : _onChange({
      target: {
        value: result
      }
    });
  };
  var reduceHandler = function reduceHandler() {
    var arg1 = (inputValue === null || inputValue === void 0 ? void 0 : inputValue.toString()) || '0';
    var arg2 = step.toString();
    var r1, r2, m, n;
    try {
      r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    n = r1 >= r2 ? r1 : r2;
    var result = ((arg1 * m - arg2 * m) / m).toFixed(n);
    setInputValue(result);
    _onChange === null || _onChange === void 0 ? void 0 : _onChange({
      target: {
        value: result
      }
    });
  };
  useEffect(function () {
    var fn = function fn() {
      if (value !== undefined && (value === null || value === void 0 ? void 0 : value.toString()) !== (inputValue === null || inputValue === void 0 ? void 0 : inputValue.toString())) {
        setInputValue(value);
      }
    };
    var t = setTimeout(fn, 300);
    return function () {
      clearTimeout(t);
    };
  }, [value, inputValue]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: cn('moly-input', 'relative flex items-center bg-base-bds-gray-ele-line border border-solid border-base-bds-gray-ele-line', 'transition-all ease-in-out  duration-100', {
        'shadow-input-shadow border border-solid border-brandColor-bds-brand-900-focus': focusStatus && !props.disabled,
        'hover:border hover:border-solid hover:border-brandColor-bds-brand-800-pressed': !props.disabled,
        'cursor-not-allowed  border-bds-input-disabled-border bg-base-bds-gray-ele-edge': props.disabled,
        'border-[#EF454A] focus-visible:border-[#EF454A]  hover:border-[#EF454A]': variant === 'error',
        'shadow-error-shadow': focusStatus && variant === 'error' && !props.disabled
      }, containerVariable[size], className),
      style: _objectSpread({
        width: width,
        height: height
      }, style),
      children: [prefix && /*#__PURE__*/_jsx("div", {
        className: cn(' inline-flex items-center ', fontSizeVariable[size]),
        children: prefix
      }), /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({
        type: inputType,
        ref: ref,
        placeholder: placeholder,
        value: inputValue,
        onKeyPress: function onKeyPress(event) {
          var _props$onKeyPress;
          if (type === 'number' && firstZero) {
            if (!/[0-9]/.test(event.key)) {
              event.preventDefault();
            }
          }
          props === null || props === void 0 ? void 0 : (_props$onKeyPress = props.onKeyPress) === null || _props$onKeyPress === void 0 ? void 0 : _props$onKeyPress.call(props, event);
        },
        onChange: function onChange(e) {
          var value = e.target.value;
          if (type === 'number') {
            value = checkNum(value);
            if (firstZero) {
              if (parseInt(value) + '' === 'NaN') {
                value = '';
              }
            }
          }
          _onChange === null || _onChange === void 0 ? void 0 : _onChange(e);
          setInputValue(value);
        },
        style: {
          background: 'transparent',
          outline: 'medium',
          caretColor: 'none',
          border: 'none',
          width: '100%'
        }
        // ADB1B8
        ,
        className: cn(fontSizeVariable[size], 'appearance-none placeholder:text-[#ADB1B8]', inputStyle, {
          'cursor-not-allowed bg-bds-input-disabled border-[#F3F5F7] text-base-bds-gray-t4-dis': props.disabled
        }),
        onFocus: function onFocus() {
          setFocusStatus(true);
        },
        onPaste: function onPaste(e) {
          var value = e.target.value;
          if (type === 'number') {
            value = checkNum(value);
            if (!firstZero) {
              value = parseFloat(value) + '';
            }
            if (isNaN(value)) {
              value = '';
            }
          }
          e.target.value = value;
          _onPaste === null || _onPaste === void 0 ? void 0 : _onPaste(e);
          setInputValue(value);
        },
        onKeyUp: function onKeyUp(e) {
          if (e.keyCode === 13 || e.which === 13) {
            onEnter === null || onEnter === void 0 ? void 0 : onEnter(inputValue);
          }
        }
      }, props), {}, {
        onBlur: function onBlur(e) {
          var _props$onBlur;
          setFocusStatus(false);
          (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 ? void 0 : _props$onBlur.call(props, e);
        }
      })), suffix && /*#__PURE__*/_jsxs(_Fragment, {
        children: [allowClear && (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) > 0 && /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(EmptyIcon, {
            onClick: onClear,
            style: {
              color: 'var(--bds-gray-t2)'
            },
            className: cn('cursor-pointer', {
              'w-[16px] h-[16px]': ['small', 'xs'].includes(size),
              'w-[20px] h-[20px]': ['medium', 'x-large'].includes(size) || !size
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: cn('justify-items-center text-brandColor-bds-brand-900-text', fontSizeVariable[size]),
          style: {
            marginRight: type === 'number' && numberControl ? '8px' : '0px'
          },
          children: suffix
        })]
      }), (type === 'password' && visible || allowClear) && !suffix && /*#__PURE__*/_jsxs("div", {
        className: cn('flex items-center'),
        children: [allowClear && (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(EmptyIcon, {
            onClick: onClear,
            style: {
              color: 'var(--bds-gray-t2)'
            },
            className: cn('cursor-pointer', {
              'w-[16px] h-[16px]': ['small', 'xs'].includes(size),
              'w-[20px] h-[20px]': ['medium', 'x-large'].includes(size) || !size
            })
          }), /*#__PURE__*/_jsx("div", {
            className: cn('border-colors-base-bds-gray-ele-border hidden mx-[8px] h-[18px] items-center', {
              block: type === 'password' && visible,
              'h-[16px] ': size === 'xs',
              'h-[18px] ': size === 'small',
              'h-[20px] ': size === 'medium',
              'h-[24px] ': size === 'x-large'
            }),
            style: {
              borderLeft: '1px solid var(--bds-gray-ele-border)'
            }
          })]
        }), type === 'password' && visible && /*#__PURE__*/_jsx(_Fragment, {
          children: passwordVisible ? /*#__PURE__*/_jsx(IconButton, {
            size: getIconSize(),
            children: /*#__PURE__*/_jsx(EyeonIcon, {
              onClick: function onClick() {
                setPasswordVisible(false);
                setInputType('password');
              }
            })
          }) : /*#__PURE__*/_jsx(IconButton, {
            size: getIconSize(),
            children: /*#__PURE__*/_jsx(EyeoffIcon, {
              onClick: function onClick() {
                setPasswordVisible(true);
                setInputType('text');
              }
            })
          })
        })]
      }), type === 'number' && numberControl && /*#__PURE__*/_jsxs("div", {
        className: cn('flex items-center'),
        children: [/*#__PURE__*/_jsx(IconButton, {
          size: getIconSize(),
          children: /*#__PURE__*/_jsx(ReduceIcon, {
            onClick: reduceHandler
          })
        }), /*#__PURE__*/_jsx("div", {
          className: cn('border-colors-base-bds-gray-ele-border mt-[2px] mx-[8px]  items-center', {
            'h-[16px] ': size === 'xs',
            'h-[18px] ': size === 'small',
            'h-[20px] ': size === 'medium',
            'h-[24px] ': size === 'x-large'
          }),
          style: {
            borderLeft: '1px solid var(--bds-gray-ele-border)'
          }
        }), /*#__PURE__*/_jsx(IconButton, {
          size: getIconSize(),
          children: /*#__PURE__*/_jsx(PlusIcon, {
            onClick: plusHandler
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: cn(inputVariants({
          variant: variant
        }), 'pl-[32px]'),
        style: {
          height: height,
          position: 'absolute',
          inset: 0,
          zIndex: 0,
          pointerEvents: 'none'
        }
      })]
    })
  });
});
Input.displayName = 'Input';
export { Input, inputVariants };